(function () {
  var root = document.getElementById('ss-cart');
  if (!root || window.ssCart) return;

  var nativeFetch = window.fetch;
  var addPattern = /\/cart\/add(\.js)?(\?|$)/;
  var headerCartLinks = '.ss-icons a[aria-label="Cart"], .ss-mob-cart a[aria-label="Cart"]';
  var focusable = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled])';
  var refreshSeq = 0;
  var recsSeq = 0;
  var lastRecs = { anchor: '', html: '' };
  var opener = null;

  function panel() {
    return root.querySelector('[data-ss-panel]');
  }

  function isOpen() {
    return root.classList.contains('is-open');
  }

  function setBadges(count) {
    document.querySelectorAll(headerCartLinks).forEach(function (link) {
      var badge = link.querySelector('.ss-badge');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'ss-badge';
          link.appendChild(badge);
        }
        badge.textContent = count > 99 ? '99+' : String(count);
      } else if (badge) {
        badge.remove();
      }
    });
  }

  function setBusy(on) {
    var p = panel();
    if (p) p.classList.toggle('is-busy', on);
  }

  function showError(message) {
    var el = root.querySelector('[data-ss-error]');
    if (el) el.textContent = message || '';
  }

  function focusKey(el) {
    if (!el || !el.closest || !el.closest('[data-ss-panel]')) return null;
    var line = el.getAttribute('data-line');
    if (el.hasAttribute('data-ss-qty-input')) return '[data-ss-qty-input][data-line="' + line + '"]';
    if (el.hasAttribute('data-ss-qty')) return '[data-ss-qty="' + el.getAttribute('data-ss-qty') + '"][data-line="' + line + '"]';
    return null;
  }

  function render(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var freshRoot = doc.querySelector('.ss-cart');
    var fresh = doc.querySelector('[data-ss-panel]');
    var current = panel();
    if (!freshRoot || !fresh || !current) return;

    var key = focusKey(document.activeElement);
    var body = current.querySelector('[data-ss-body]');
    var top = body ? body.scrollTop : 0;

    current.innerHTML = fresh.innerHTML;
    current.classList.remove('is-busy');
    root.setAttribute('data-count', freshRoot.getAttribute('data-count') || '0');
    root.setAttribute('data-products', freshRoot.getAttribute('data-products') || '');
    setBadges(parseInt(root.getAttribute('data-count'), 10) || 0);

    body = current.querySelector('[data-ss-body]');
    if (body) body.scrollTop = top;
    if (isOpen()) {
      var again = key && current.querySelector(key);
      (again || current.querySelector('.ss-cart__close') || current).focus({ preventScroll: true });
    }
    loadRecs();
  }

  function refresh() {
    var id = ++refreshSeq;
    return nativeFetch('/?sections=cart-drawer&t=' + Date.now(), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (id === refreshSeq) render(data['cart-drawer']);
      })
      .catch(function () {});
  }

  function post(url, payload) {
    payload.sections = 'cart-drawer';
    return nativeFetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) { return res.json(); });
  }

  function change(line, quantity) {
    setBusy(true);
    showError('');
    return post('/cart/change.js', { line: Number(line), quantity: quantity })
      .then(function (data) {
        if (data.sections && data.sections['cart-drawer']) {
          refreshSeq++;
          render(data.sections['cart-drawer']);
        } else {
          setBusy(false);
        }
        if (data.description) showError(data.description);
      })
      .catch(function () {
        setBusy(false);
        showError('Something went wrong. Please try again.');
      });
  }

  function addRec(button) {
    var card = button.closest('[data-ss-rec]');
    var select = card && card.querySelector('[data-ss-rec-variant]');
    var id = select ? select.value : button.getAttribute('data-variant');
    if (!id) return;
    var label = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding';
    setBusy(true);
    return post('/cart/add.js', { items: [{ id: Number(id), quantity: 1 }] })
      .then(function (data) {
        if (data.sections && data.sections['cart-drawer']) {
          refreshSeq++;
          render(data.sections['cart-drawer']);
        } else {
          setBusy(false);
          button.disabled = false;
          button.textContent = label;
          showError(data.description || 'That item could not be added.');
        }
      })
      .catch(function () {
        setBusy(false);
        button.disabled = false;
        button.textContent = label;
      });
  }

  function fetchRecs(anchor, intent) {
    var url = '/recommendations/products?section_id=ss-cart-recs&limit=10&intent=' + intent + '&product_id=' + encodeURIComponent(anchor);
    return nativeFetch(url, { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.text() : ''; })
      .then(function (text) {
        var out = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-ss-recs-out]');
        return out ? out.innerHTML.trim() : '';
      })
      .catch(function () { return ''; });
  }

  function withoutCartItems(html) {
    var box = document.createElement('div');
    box.innerHTML = html;
    var ids = root.getAttribute('data-products') || '';
    box.querySelectorAll('[data-pid]').forEach(function (li) {
      if (ids.indexOf(',' + li.getAttribute('data-pid') + ',') > -1) li.remove();
    });
    return box.querySelector('[data-ss-rec-item]') ? box.innerHTML : '';
  }

  function loadRecs() {
    var holder = root.querySelector('[data-ss-recs]');
    var anchor = holder && holder.getAttribute('data-anchor');
    if (!anchor) return;
    if (lastRecs.anchor === anchor && lastRecs.html) holder.innerHTML = withoutCartItems(lastRecs.html);

    var id = ++recsSeq;
    fetchRecs(anchor, 'complementary')
      .then(function (html) { return html || fetchRecs(anchor, 'related'); })
      .then(function (html) {
        if (id !== recsSeq) return;
        lastRecs = { anchor: anchor, html: html };
        var target = root.querySelector('[data-ss-recs]');
        if (target) target.innerHTML = html;
      });
  }

  function open(trigger) {
    if (!isOpen()) opener = trigger || document.activeElement;
    root.classList.add('is-open');
    document.body.classList.add('ss-cart-open');
    window.setTimeout(function () {
      var p = panel();
      if (!p) return;
      (p.querySelector('.ss-cart__close') || p).focus({ preventScroll: true });
    }, 60);
  }

  function close() {
    root.classList.remove('is-open');
    document.body.classList.remove('ss-cart-open');
    if (opener && opener.focus && document.body.contains(opener)) opener.focus({ preventScroll: true });
    opener = null;
  }

  root.addEventListener('click', function (event) {
    var t = event.target;
    if (!t.closest) return;
    if (t.closest('[data-ss-close]')) {
      close();
      return;
    }
    var step = t.closest('[data-ss-qty]');
    if (step) {
      var line = step.getAttribute('data-line');
      var input = root.querySelector('[data-ss-qty-input][data-line="' + line + '"]');
      var current = input ? parseInt(input.value, 10) || 0 : 0;
      change(line, Math.max(0, current + parseInt(step.getAttribute('data-ss-qty'), 10)));
      return;
    }
    var remove = t.closest('[data-ss-remove]');
    if (remove) {
      change(remove.getAttribute('data-line'), 0);
      return;
    }
    var add = t.closest('[data-ss-rec-add]');
    if (add) addRec(add);
  });

  root.addEventListener('change', function (event) {
    var input = event.target.closest && event.target.closest('[data-ss-qty-input]');
    if (!input) return;
    change(input.getAttribute('data-line'), Math.max(0, parseInt(input.value, 10) || 0));
  });

  root.addEventListener('keydown', function (event) {
    if (!isOpen()) return;
    if (event.key === 'Escape') {
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    var p = panel();
    var items = Array.prototype.filter.call(p.querySelectorAll(focusable), function (el) {
      return el.getClientRects().length > 0;
    });
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === p)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t.closest || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey) return;
    var trigger = t.closest(headerCartLinks + ', [data-ss-cart-open]');
    if (!trigger || window.location.pathname === '/cart') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    open(trigger);
    refresh();
  }, true);

  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var result = nativeFetch.apply(this, arguments);
    if (addPattern.test(url)) {
      result.then(function (res) {
        if (res && res.ok) refresh().then(function () { open(); });
      }, function () {});
    }
    return result;
  };

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refresh();
  });

  window.ssCart = { open: open, close: close, refresh: refresh };
})();